import React, { useState } from "react";
import { PersonInfo } from "../../../models/customer.model";
import BorderedLayout from "../../../layouts/BorderedLayout";
import { Box, Grid, Typography } from "@mui/material";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import ModalCancel from "../../../components/modals/ModalCancel";
import { useMutation } from "react-query";
import { ChangeBlacklistState } from "../../../services/customer.service";
import { ApiResultModel } from "../../../models/common.model";
import { toast } from "react-toastify";

interface Props {
  personInfo: PersonInfo;
  handleDetail: Function;
}

const CustomerHeader = ({ personInfo, handleDetail }: Props) => {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const ChangeState = () => {
    ChangeBlacklistStateMutate({
      customerId: Number(personInfo.id),
    });
  };
  const { mutate: ChangeBlacklistStateMutate } = useMutation(
    ChangeBlacklistState,
    {
      onSuccess: (data: ApiResultModel<boolean>) => {
        if (data.isSuccess === true) {
          toast.success("عملیات با موفقیت انجام شد");
          setOpenModal(false);
          handleDetail(personInfo.id);
        } else toast.error(data.data);
      },
    }
  );

  return (
    <div>
      <Grid
        container
        sx={{
          backgroundColor: "#F6F8F9",
          border: "1px solid #EDEFEF",
          borderRadius: "5px",
          padding: "10px 25px",
          alignItems: "center",
          justifyContent: "flex-end",
          mb: "20px",
        }}
      >
        <Grid item>
          <Box
            sx={{
              display: { xs: "block", md: "flex" },
              alignItems: "center",
              gap: "10px",
            }}
          >
            {personInfo?.allowBlacklistChange === true ? (
              personInfo?.isInBlacklist === false ? (
                <Typography
                  sx={{ color: "#E6123D", cursor: "pointer" }}
                  onClick={() => setOpenModal(true)}
                >
                  <CheckOutlinedIcon
                    sx={{ fontSize: "1.5rem", marginLeft: "3px" }}
                  />
                  انتقال به لیست سیاه
                </Typography>
              ) : (
                <Typography
                  sx={{ color: "#28A745", cursor: "pointer" }}
                  onClick={() => setOpenModal(true)}
                >
                  <ClearOutlinedIcon
                    sx={{ fontSize: "1.5rem", marginLeft: "3px" }}
                  />
                  خروج از لیست سیاه
                </Typography>
              )
            ) : (
              ""
            )}
          </Box>
        </Grid>
      </Grid>
      <Grid>
        <BorderedLayout
          title={
            <Typography
              sx={{
                color: "#1D4A87",
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
            >
              مشخصات متقاضی
            </Typography>
          }
          backgroundColor="#F9FAFC"
        >
          <Grid container sx={{ padding: "20px" }} gap={"20px"}>
            {/* top section */}
            <Grid item xs={12}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid item xs={3}>
                  <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                    نام و نام خانوادگی:{" "}
                    <span style={{ color: "#34495E" }}>
                      {personInfo?.customerFullName}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                    کد ملی:{" "}
                    <span style={{ color: "#34495E" }}>
                      {personInfo?.customerNationalCode}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                    شماره شناسنامه:{" "}
                    <span style={{ color: "#34495E" }}>
                      {personInfo?.customerShenasnamehNumber}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                    تاریخ تولد:{" "}
                    <span style={{ color: "#34495E" }}>
                      {personInfo?.customerBirthDatePersian}
                    </span>
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            {/* middle section  */}
            <Grid item xs={12}>
              <Grid
                container
                spacing={{ xs: 2, md: 3 }}
                columns={{ xs: 4, sm: 8, md: 12 }}
              >
                <Grid item xs={3}>
                  <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                    نام پدر:{" "}
                    <span style={{ color: "#34495E" }}>
                      {personInfo?.customerFatherName}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                    سری/سریال شناسنامه:{" "}
                    <span style={{ color: "#34495E" }}>
                      {`${personInfo?.customerSerialNumber} / ${personInfo?.customerSeriNumber}`}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}>
                  <Typography sx={{ color: "#9AAFC4", fontSize: "1rem" }}>
                    شماره همراه:{" "}
                    <span style={{ color: "#34495E" }}>
                      {personInfo?.customerMobileNumber}
                    </span>
                  </Typography>
                </Grid>
                <Grid item xs={3}></Grid>
              </Grid>
            </Grid>
            {/* description section */}
            {personInfo?.customerAddresses.length > 0 && (
              <Grid
                item
                xs={12}
                sx={{
                  borderTop: "1px solid #C1C7CB",
                  paddingTop: "20px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "15px",
                }}
              >
                <Typography
                  sx={{
                    color: "#1D4A87",
                    fontSize: "1.1rem",
                    fontWeight: "bold",
                  }}
                >
                  مشخصات سکونتی
                </Typography>
                {personInfo?.customerAddresses.map((address, index) => (
                  <Typography
                    key={index}
                    sx={{ color: "#9AAFC4", fontSize: "1rem" }}
                  >
                    آدرس/کدپستی:{" "}
                    <span
                      style={{ color: "#34495E" }}
                    >{`${address?.address} / ${address?.postalCode}`}</span>
                  </Typography>
                ))}
              </Grid>
            )}
          </Grid>
        </BorderedLayout>
      </Grid>
      <ModalCancel
        title={""}
        bgColor={"kamanColor"}
        setValue={ChangeState}
        openModal={openModal}
        setOpenModal={setOpenModal}
      />
    </div>
  );
};

export default CustomerHeader;
